import type { CheckDepthTier, TierKey } from '@nestjs-boilerplate/types';

import { TIERS } from '@/features/payments';

export interface TierFeature {
  text: string;
  included: boolean;
}

export interface TierConfig {
  id: CheckDepthTier;
  name: string;
  description: string;
  features: TierFeature[];
  includesFrom?: CheckDepthTier;
  // Pricing-table row whose `priceGBP` is what the user pays at tier selection.
  // Edit that row (Prisma Studio / SQL) to change what a tier costs; service-row
  // prices remain independent and drive only a la carte upgrade modals.
  tierKey: TierKey;
}

export const TIER_CONFIGS: Record<CheckDepthTier, TierConfig> = {
  basic: {
    id: 'basic',
    name: 'Basic',
    description: 'Run selected checks with clear match/no match results',
    tierKey: TIERS.basic,
    features: [
      { text: 'Run selected screening checks', included: true },
      { text: 'Match found or clear result per check', included: true },
      { text: 'Summary risk level indication', included: true },
    ],
  },
  standard: {
    id: 'standard',
    name: 'Standard',
    description: 'Detailed screening with supporting evidence',
    includesFrom: 'basic',
    tierKey: TIERS.standard,
    features: [{ text: 'Match Risk Report with detailed findings', included: true }],
  },
  enhanced: {
    id: 'enhanced',
    name: 'Enhanced',
    description: 'Deep analysis of all articles with AI confidence scoring',
    includesFrom: 'standard',
    tierKey: TIERS.enhanced,
    features: [
      { text: 'Enhanced Due Diligence', included: true },
      { text: 'Full article extraction', included: true },
      { text: 'AI confidence scoring', included: true },
    ],
  },
};

export const TIER_ORDER: CheckDepthTier[] = ['basic', 'standard', 'enhanced'];
